import { action, extendObservable, useStrict } from 'mobx';
// import * as local from '../helpers/localStorage';
import default_avatar from '../assets/images/user_top_navbar_icon.svg';

import {
    apiFetchGet,
    apiFetchPostWithoutToken,
    fetchSignIn,
    apiFetchUrlGet,
    apiFetchPostJson,
    apiFetchPostJsonMulti,
    apiFetchGetLocalServer,
} from '../helpers/api';

import uuid from '../helpers/uuid';
// import { webkit } from '../helpers/utils';

import {
    GET_PROFILE,
    PUT_PROFILE,
    GET_CAPTCHA,
    REQUEST_FORGOTTEN,
    REQUEST_LOGIN,
    REQUEST_VERIFYUSERPORTALTOKEN,
    REQUEST_ISUSERNAMEUNIQUE,
    REQUEST_REGISTER,
    REQUEST_VERIFYUSERPORTALPASSWORDTOKEN,
    REQUEST_RESET_PASSWORD,
    PUT_AVATAR,
    APP_TYPE_WEB_APP,
    APP_TYPE_ELECTRON_APP,
    REQUEST_LOCAL_HOST,
    OFFLINE_ACCESS_TOKEN,
} from '../helpers/constants';

import { SHA256 } from '../helpers/utils';
import store from './store';

let remote;
if (window.require) {
    remote = window.require('electron').remote;
}

useStrict(true);

export default class UserStore {
    constructor(factory) {
        this.userClientId = uuid();

        extendObservable(this, {
            data: null,
            token: null,
            pinValidated: false,
            pinExists: false,
            loggedIn: false,
            selectedIndex: 0,
            editProfile: 0,
            profile: [],
            shouldShowCloseAppModal: false,
            newUserTryingToLogin: false,
            tempJsonObject: null,
            localAvatarUrl: '../src/assets/images/User.png', // TODO need to decide where this image will be stored
            profileSwitchData: [],
            currentProfile: 0,

            setData: action(json => {
                this.data = json;
            }),

            set: action((field, value) => {
                this[field] = value;                
            }),
            setToken: action(token => {
                this.token = token;
            }),

            setTempJsonObject: action(json => {
                this.tempJsonObject = json;
            }),

            setAvatarUrl: action(url => {
                this.localAvatarUrl = url;
            }),

            toggleSelected: action(index => {
                this.selectedIndex = index;
            }),

            profileToEdit: action(index => {
                this.editProfile = index;
            }),

            /**
             * Get user profile, store to user.data
             */
            fetch: () => {
                return apiFetchGet(GET_PROFILE, this.token)
                    .then(json => {
                        this.setData(json);
                        this.fetchAvatar(json.AvatarUrl);
                        this.fetchProfile(json.Profiles);
                    })
                    .catch(e => {
                        if (!e instanceof TypeError) {
                            if (e.spread.status === 401) {
                                this.logout();
                            }
                        }
                        return e;
                    });
                // return true;
            },

            initilizeUserProfile: action(() => {
                this.profile = [];
            }),

            showCloseAppModal: action(() => {
                this.shouldShowCloseAppModal = true;
            }),

            hideCloseAppModal: action(() => {
                this.shouldShowCloseAppModal = false;
            }),

            setNewUserTryingToLogin: action(value => {
                this.newUserTryingToLogin = value;
            }),

            changeAppUser: action(async () => {
                let userId = await window.offlineApiExtension.loadActor('userId');
                let notSameUser = userId !== this.tempJsonObject.Id;
                // let syncNotesOfPreviousUser = await window.offlineApiExtension.syncNotesInDB(
                await window.offlineApiExtension.syncLocalWithServer(
                    notSameUser,
                    userId,
                );
                // console.log("changeAppUser", syncNotesOfPreviousUser);
                // let deleteDb = await window.offlineApiExtension.deleteData();
                await window.offlineApiExtension.deleteData();

				localStorage.clear();

                // let saveRefreshToken = await window.offlineApiExtension.saveActor(
                await window.offlineApiExtension.saveActor(
                    'refreshToken',
                    this.tempJsonObject.refresh_token,
                );

                // let saveUser = await window.offlineApiExtension.saveActor(
                await window.offlineApiExtension.saveActor(
                    'userId',
                    this.tempJsonObject.Id,
                );

                this.setTempJsonObject(null);
                this.setLoggedIn(true);
            }),

            async logout(history) {
                if (window.offlineApiExtension && window.require) {
                    // let tok = await this.deleteRefreshTokenAndOfflineKeyFromStorage();
                    // let del = await window.offlineApiExtension.deleteDataExceptActor();
                    await this.deleteRefreshTokenAndOfflineKeyFromStorage();
                    await window.offlineApiExtension.deleteDataExceptActor();
					localStorage.clear();
                    remote.getCurrentWindow().webContents.session.clearCache(() => {});
                    this.setLoggedIn(false);
                }
                else {                        
                    store.initialise();              
                }

                if (window.offlineApiExtension && window.require) {
                    window.location.reload();
                }
                else {
                    this.factory.user.setToken(null)
                    if(history !== undefined) {
                        history.push("/");
                    }  
                    else {
                        window.location.href = window.location.origin + "/login";
                    }              
                }
            },

            // Electron user needs to be flagged as requiring their PIN
            askForPin() {
                this.setPinValidated(false);
            },

			// Electron user needs to sign in again
			askToReauthenticate() {
                this.deleteRefreshTokenFromStorage();
				this.setPinValidated(false);
                this.setLoggedIn(false);
            },

            /**
             * Sign In method, set token to cookies,
             */
			login: credentials => {
                let MAC = window.offlineApiExtension && window.offlineApiExtension.getMAC();

                const body =
                    'grant_type=password&username=' +
                    credentials.username +
                    '&password=' +
                    escape(credentials.password) +
                    //  '&apptype=' + APP_TYPE_WEB_APP
                    '&apptype=' +
                    (window.offlineApiExtension ? APP_TYPE_ELECTRON_APP : APP_TYPE_WEB_APP) +
                    '&deviceId=' +
                    MAC +
                    '&captcha=' + 
                    credentials.captcha
                    ;

                return fetchSignIn(REQUEST_LOGIN, body).then(json => {
                    if (!json.error) {
                        this.setToken(json.access_token);

                        // 1. CHECK IF IT IS AN ELECTRON APP
                        if (window.offlineApiExtension) {
                            // 2. CHECK if refresh_token exists; if not, return error that redirects user to error form
                            if (json.refresh_token === undefined) {
                                this.setToken(null);
                                window.offlineApiExtension.deleteData();
								localStorage.clear();
                                this.deletePinAndOfflineKeyFromStorage();
                                return { error: true };
                            }

                            // 3. GET USER ID;
                            window.offlineApiExtension.loadActor('userId').then(userId => {
                                // 4. IF SAVED VALUE IS NOT UNDEFINED AND PREVIOUS USER EXISTS
                                if (userId !== undefined && userId !== json.Id) {
                                    this.setTempJsonObject(json);
                                    this.setNewUserTryingToLogin(true);
                                } else {
                                    this.setLoggedIn(true);
                                    // 5. Save refresh token
                                   // let saveRefreshToken = window.offlineApiExtension.saveActor(
                                   window.offlineApiExtension.saveActor(
                                        'refreshToken',
                                        json.refresh_token,
                                    );
                                    //  6. SYNC NOTES
                                    // let syncNotes = window.offlineApiExtension
                                    window.offlineApiExtension
                                        .syncLocalWithServer(false, null)
                                        .then(() => {
                                            //  7. USER IS A NEW ONE, SAVE THE USER ID AND GO THE PIN SCREEN TO SET THE PIN
                                            // let saveActor = window.offlineApiExtension.saveActor(
                                            window.offlineApiExtension.saveActor(
                                                'userId',
                                                json.Id,
                                            );
                                        });
                                        // console.log("fetchSignIn sync notes?");
                                }
                            });
                        } else {
                            this.factory.documents.setDocumentToken();
                        }

                        return json;
                    }
                });
            },

            async refreshBearerToken() {
                let refreshToken = await window.offlineApiExtension.loadActor('refreshToken');
                var json = {
                    access_token: OFFLINE_ACCESS_TOKEN,
                    refresh_token: refreshToken,
                };

                if (this.factory.conn.isOnline) {
					let MAC = window.offlineApiExtension && window.offlineApiExtension.getMAC();

                    const body =
                        'grant_type=refresh_token' +
                        '&refresh_token=' +
                        refreshToken +
                        '&apptype=' +
                        APP_TYPE_ELECTRON_APP +
                        '&deviceId=' +
                        MAC;

                    const tokenResponse = await fetchSignIn(REQUEST_LOGIN, body).catch((err) => {
						json.refresh_token = undefined;
						// return err;
					});

                    if(tokenResponse !== null && tokenResponse !== undefined) {
                        json = tokenResponse;
                    }
                }

                if (json.refresh_token === undefined) {
                    json = { error: true };
                }

                if (!json.error) {
                    this.setToken(json.access_token);
                    this.setLoggedIn(true);

                    if (await this.factory.conn.checkOnlineStatus()) {
                        await window.offlineApiExtension.saveActor(
                            'refreshToken',
                            json.refresh_token,
                        );

						await window.offlineApiExtension.syncLocalWithServer(false, null);
                    }
                    return true;
                } else {
                    // this.deletePinAndOfflineKeyFromStorage();
                    // window.offlineApiExtension.deleteData();

					//IHT: BT-1433, no longer deleting content, instead, sending user to the login page - along with message to the user
					this.askToReauthenticate();
					return false;
                }
            },

            /**
             * Forgot password method
             */

            forgotPassword: body => {
                return apiFetchPostWithoutToken(REQUEST_FORGOTTEN, body);
            },

            verifyUserPortalToken: token => {
                var body = 'Token=' + token;
                return apiFetchPostWithoutToken(REQUEST_VERIFYUSERPORTALTOKEN, body);
            },

            isUsernameUnique: payload => {
                // console.log('isUsernameUnique payload', payload);
                var body = 'UserName=' + payload;
                return apiFetchPostWithoutToken(REQUEST_ISUSERNAMEUNIQUE, body);
            },

            register: credentials => {
                const body =
                    'username=' +
                    credentials.username +
                    '&UserPassword=' +
                    escape(credentials.password) +
                    '&Token=' +
                    credentials.token;
                return apiFetchPostWithoutToken(REQUEST_REGISTER, body);
            },

            verifyUserPortalPasswordToken: token => {
                var body = 'Token=' + token;
                return apiFetchPostWithoutToken(REQUEST_VERIFYUSERPORTALPASSWORDTOKEN, body);
            },

            reset: credentials => {
                const body =
                    'username=' +
                    credentials.username +
                    '&UserPassword=' +
                    escape(credentials.password) +
                    '&Token=' +
                    credentials.token;
                return apiFetchPostWithoutToken(REQUEST_RESET_PASSWORD, body);
            },

            updateProfile: userProfile => {
                // We have to build the string
                const body = {
                    FirstName: userProfile.firstname,
                    Surname: userProfile.surname,
                    Profiles: [
                        {
                            InstanceId: userProfile.instanceid,
                            Title: userProfile.title,
                            Phone1: userProfile.phone1,
                            Phone2: userProfile.phone2,
                            EmailAddress: userProfile.emailaddress,
                            Address1: userProfile.address1,
                            Address2: userProfile.address2,
                            Suburb: userProfile.suburb,
                            State: userProfile.state,
                            Postcode: userProfile.postcode,
                            Country: userProfile.country,
                            SharePhone1: userProfile.shouldSharePhone1,
                            SharePhone2: userProfile.shouldSharePhone2,
                            ShareEmailAddress: userProfile.shouldShareEmailAddress
                        },
                    ],
                };

                //console.log(body);

                return apiFetchPostJson(PUT_PROFILE, this.token, JSON.stringify(body))
                    .then(json => {
                        // console.log('UserStore ava', json);
                    })
                    .catch(error => {
                        // console.log('UserStore error saving user profile', error);
                        //this.setAvatar();
                    });
            },

            getCaptcha: async () => {
                let ts = await apiFetchGet(GET_CAPTCHA, null, null);
                return ts
            },

            updateAvatar: file => {
                // let reader = new FileReader();
                // let AvatarBlobTemp = new Object();
                let currentToken = this.token;

                var data = new FormData();
                data.append('AvatarName', file);

                return apiFetchPostJsonMulti(PUT_AVATAR, currentToken, file)
                    .then(json => {
                        // console.log('User Avatar ava', json);
                    })
                    .catch(error => {
                        // console.log('UserStore error saving user profile', error);
                        //this.setAvatar();
                    });
                /*
                reader.readAsDataURL(file);

                reader.onload = function(e) {
                    AvatarBlobTemp.base64 = reader.result;

                    // We have to build the string
                    const body = {
                        AvatarName: AvatarBlobTemp
                    };

                   //  console.log(body);
                    return apiFetchPostJsonMulti(
                        PUT_AVATAR,
                        currentToken,
                        AvatarBlobTemp
                    )
                        .then(json => {
                            // console.log("User Avatar ava", json);
                        })
                        .catch(error => {
                            // console.log(
                               //  "UserStore error saving user profile",
                               //  error
                            // );
                            //this.setAvatar();
                        });
                };*/

                //store.user.updateAvatar(this.file);
                /*reader.readAsDataURL(file);

                reader.onload = function(e) {
                    AvatarBlobTemp.base64 = reader.result;
                };
                */
            },

            fetchAvatar: imageUrl => {
                if (!imageUrl || imageUrl === '') {
                    return this.setAvatarUrl(default_avatar);
                } else {
                    return apiFetchUrlGet(imageUrl, this.token)
                        .then(json => {
                            //console.log("UserStore ava", json);
                            this.setAvatarUrl(json);
                        })
                        .catch(error => {
                            // console.log('UserStore error getting the avatar', error);
                            return this.setAvatarUrl(default_avatar);
                        });
                }
            },

            fetchProfile: Profiles => {
                Profiles = this.sortAZ(Profiles);

                Profiles.forEach((profiles, i) => {
                    this.setProfiles(profiles, i);
                });
            },

            setProfiles: action((profiles, index) => {
                //console.log('ProfileStore groups test', profiles);
                this.profile[index] = profiles;
            }),

            //#region PIN AREA
            /**
             * Fetch pin from local server
             * @param {string} pin user pin value
             * @returns {json} json data
             */
            fetchLocal: pin => {
                return apiFetchGetLocalServer(REQUEST_LOCAL_HOST, { pin: pin }).then(json => {
                    return json;
                });
            },

            /**
             * Set pin func
             * @param {string} value user pin value
             */
            setPinValidated: action(value => {
                this.pinValidated = value;
            }),

            /**
             * Get pin func
             * Values: true or false
             * @returns {bool} true or false
             */
            get isPinValidated() {
                return this.pinValidated;
            },

            /**
             * Set pin exists func
             * @param {bool} true or false
             */
            setPinExists: action(value => {
                this.pinExists = value;
            }),

            /**
             * Set LoggedIn func
             * @param {bool} true or false
             */
            setLoggedIn: action(value => {
                this.loggedIn = value;
            }),

            /**
             * Set Pin value func
             * @param {string} value of the pin
             */
            async setPinValue(value) {
                let userId = await window.offlineApiExtension.loadActor('userId');
                let pepperPin = value + userId;
                let hashedPin = SHA256(pepperPin);
                let savedPin = window.offlineApiExtension.saveActor('hashedPin', hashedPin);

                // let isOnline = await window.offlineApiExtension.isOnline();
                let isOnline = await this.factory.conn.checkOnlineStatus();
                // if (savedPin && this.isOnline) {
                if (savedPin && isOnline) {
                    // let token = await this.factory.documents.setOfflineDocumentToken(hashedPin);
                    await this.factory.documents.setOfflineDocumentToken(hashedPin);
                }
            },

            /**
             * @returns {string} pin value from the idb
             */
            async getValueFromActorStorage(actorKey) {
                return await window.offlineApiExtension.loadActor(actorKey);
            },

            /**
             * @returns {string} pin value from a cookie
             */
            async deletePinAndOfflineKeyFromStorage() {
                let pin = await window.offlineApiExtension.deleteActor('hashedPin');
                let key = await window.offlineApiExtension.deleteActor('offlineKey');
                let token = await window.offlineApiExtension.deleteActor('refreshToken');
                return pin && key && token;
            },
            async deleteRefreshTokenFromStorage() {
                let token = await window.offlineApiExtension.deleteActor('refreshToken');
                return token;
            },

            async deleteRefreshTokenAndOfflineKeyFromStorage() {
                let key = await window.offlineApiExtension.deleteActor('offlineKey');
                let token = await window.offlineApiExtension.deleteActor('refreshToken');
                return token && key;
            },

            /**
             * @returns {bool} true or false
             */
            async comparePinWithValueInStorage(val) {
                let userId = await window.offlineApiExtension.loadActor('userId');
                let pepperPin = val + userId;
                let hashedPin = SHA256(pepperPin);
                let savedHashedPin = await this.getValueFromActorStorage('hashedPin');

                if (savedHashedPin === hashedPin) {
                    return true;
                } else {
                    return false;
                }
            },

            //#endregion
        });

        this.factory = factory;
        // Get token from cookies when create user instance
        //this.setTokenFromCookie();
    }

    // sort alphabetically
    sortAZ = array => {
        return array.sort((a, b) => {
            return a.Company > b.Company;
        });
    };
}



// WEBPACK FOOTER //
// ./src/stores/UserStore.js